import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const timeframeMap: Record<Timeframe, MapItem> = {
  less_than_one_month: { label: 'Less than 1 month' },
  one_to_three_months: { label: '1-3 months' },
  three_to_six_months: { label: '3-6 months' },
  more_than_six_months: { label: 'More than 6 months' },
}

export const timeframeSchema = z.enum(Object.keys(timeframeMap) as [Timeframe, ...Timeframe[]])

export type Timeframe = 'less_than_one_month' | 'one_to_three_months' | 'three_to_six_months' | 'more_than_six_months'
